export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'API', href: '#api' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Integrations', href: '#integrations' },
  { label: 'Docs', href: '#docs' },
  { label: 'Get Started', href: '#get-started' },
];
